import { buildSessionEvent, buildMiniGameEvent } from './events.js';
import { appendEvent } from './outbox.js';

/**
 * Bridges a committed session / mini-game to the progress slice's outbox.
 *
 * These are called from `progressStore` ONLY when the sync feature flag is on
 * (SYNC_ENABLED). They are pure: given a progress slice + a commit summary they
 * return the NEW outbox array (event appended, deduped by id) without mutating
 * the slice. The event carries only the slice's profileId/deviceId + aggregate
 * summary — never raw answers.
 */

function toIso(now) {
  return (now instanceof Date ? now : new Date(now ?? Date.now())).toISOString();
}

export function appendSessionToOutbox(slice, { summary, mode = 'practice', grade = null, now = new Date() } = {}) {
  const event = buildSessionEvent({
    profileId: slice?.profileId ?? null,
    deviceId: slice?.deviceId ?? null,
    summary: summary ?? {},
    mode,
    grade,
    committedAt: toIso(now),
  });
  return appendEvent(slice?.outbox, event);
}

export function appendMiniGameToOutbox(slice, { summary, kind = 'grammar_rule', grade = null, now = new Date() } = {}) {
  const event = buildMiniGameEvent({
    profileId: slice?.profileId ?? null,
    deviceId: slice?.deviceId ?? null,
    summary: summary ?? {},
    kind,
    grade,
    committedAt: toIso(now),
  });
  return appendEvent(slice?.outbox, event);
}
